module.exports = __webpack_public_path__ + "media/images/riders/ELEONORA_FARINA-08dea9eeaefff47bdaf89b6baf41d976.png";